// Separate Whop attribution. Existing Shopify/Elevar destinations are untouched.
(function () {
  'use strict';
  if (window.__snatchdWhopConsent) return;
  window.__snatchdWhopConsent = true;
  var account = 'biz_exYrmyMRrvJL0a';
  var initialized = false;
  var pageSent = false;
  var ownsPixel = false;
  var retries = 0;
  var options = {
    autoPage: false, forms: false, urlIdentity: false,
    links: false, iframes: false, sc: false
  };

  function allowed() {
    try {
      var privacy = window.Shopify && window.Shopify.customerPrivacy;
      return !!privacy && privacy.analyticsProcessingAllowed() === true &&
        privacy.marketingAllowed() === true && privacy.saleOfDataAllowed() === true;
    } catch (_) { return false; }
  }

  function sync() {
    if (!allowed()) {
      if (ownsPixel && window.whop) {
        window.whop.setScope();
        // Remove events queued before a consent change while the SDK loads.
        if (!window.whop.started) pageSent = false;
        if (Array.isArray(window.whop.q)) window.whop.q.length = 0;
        window.whop.s = [];
      }
      return;
    }
    if (!initialized) {
      // Do not replace a separately installed SDK or duplicate its destination.
      if (window.whop) return;
      initialized = true;
      ownsPixel = true;
      var pixel = window.whop = {
        q: [], t: Date.now(), s: [], o: 'https://t.whop.tw', c: options,
        track: function () {
          pixel.q.push([Date.now()].concat(Array.prototype.slice.call(arguments)));
        },
        setScope: function () {
          pixel.s = Array.prototype.slice.call(arguments).filter(function (id) { return typeof id === 'string'; });
          pixel.q.push([Date.now(), 'setScope'].concat(pixel.s));
        },
        scope: function () {
          var scope = Array.prototype.slice.call(arguments);
          return { track: function () {
            if (allowed()) pixel.q.push([Date.now()].concat(Array.prototype.slice.call(arguments), [{ __scope: scope }]));
          } };
        }
      };
      var script = document.createElement('script');
      script.async = true;
      script.src = pixel.o + '/s.js';
      script.onload = sync;
      (document.head || document.documentElement).appendChild(script);
    }
    if (!ownsPixel) return;
    window.whop.setScope(account);
    if (typeof window.whop.config === 'function') window.whop.config(options);
    if (!pageSent) {
      window.whop.track('page');
      pageSent = true;
    }
  }

  function ready() {
    if (window.Shopify && window.Shopify.customerPrivacy) { sync(); return; }
    if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
        if (!error) sync();
      });
      return;
    }
    // Fail closed when Shopify's privacy API is unavailable.
    if (++retries <= 20) window.setTimeout(ready, 250);
  }
  document.addEventListener('visitorConsentCollected', sync);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready, { once: true });
  else ready();
})();
